import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { ROYAL_BLUE_2, SANTAS_GRAY, WHITE } from '@/constants/colors';

// UTILITY
import breakpoints from '@/utility/breakpoints';

export const Container = styled.div`
  &.content-hero.content-hero--default-brand.content-hero--lighten {
    .filters__advanced-button.MuiButton-root {
      color: ${WHITE} !important;
      background-color: transparent !important;
      border: 2px solid ${WHITE} !important;
      box-shadow: none !important;
      padding-top: 15px;
      padding-bottom: 15px;

      .MuiButton-label {
        color: ${WHITE} !important;
      }

      .MuiButton-endIcon,
      .MuiSvgIcon-root {
        color: ${WHITE} !important;
      }

      &:hover {
        background-color: ${rgba(WHITE, 0.08)} !important;
        border-color: ${WHITE} !important;

        .MuiButton-label {
          color: ${WHITE} !important;
        }
      }

      &:disabled {
        color: ${rgba(WHITE, 0.7)} !important;
        border-color: ${rgba(WHITE, 0.7)} !important;

        .MuiButton-label {
          color: ${rgba(WHITE, 0.7)} !important;
        }
      }
    }
  }

  &.content-hero.content-hero--default-brand {
    background-color: ${ROYAL_BLUE_2};
    color: ${WHITE};

    .content-hero__title,
    .content-hero__subtitle {
      color: ${WHITE};
    }

    &.content-hero--left-bg .page-content::before {
      background-color: ${ROYAL_BLUE_2};
    }

    &.content-hero--right-bg .page-content::after {
      background-color: ${ROYAL_BLUE_2};
    }

    .sticky-outer-wrapper.active .content-hero__content {
      background-color: ${ROYAL_BLUE_2};

      &::before,
      &::after {
        background-color: ${ROYAL_BLUE_2};
      }
    }
  }

  .content-hero,
  &.content-hero {
    background-color: ${p => p.theme.palette.background.contentHero};

    &--left-bg {
      .page-content {
        position: relative;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          background-color: ${p => p.theme.palette.background.contentHero};
          height: 100%;
          width: 100%;
        }

        &::before {
          right: 100%;
        }
      }
    }

    &--right-bg {
      .page-content {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          top: 0;
          background-color: ${p => p.theme.palette.background.contentHero};
          height: 100%;
          width: 100%;
        }

        &::after {
          left: 100%;
        }
      }
    }

    &--lighten {
      color: ${WHITE};

      .MuiInputBase-root {
        background-color: ${WHITE};
        box-shadow: 0 4px 24px rgba(42, 42, 53, 0.15);

        input {
          &::placeholder {
            color: ${SANTAS_GRAY};
          }
        }

        &.Mui-disabled {
          background-color: ${rgba(WHITE, 0.7)};
        }
      }

      .MuiButtonBase-root {
        background-color: transparent;
        border: 2px solid ${WHITE};
        color: ${WHITE};
        box-shadow: none;
        padding-top: 15px;
        padding-bottom: 15px;

        .MuiButton-label {
          color: ${WHITE};
        }

        .MuiButton-endIcon,
        .MuiSvgIcon-root {
          color: ${WHITE};
        }

        &:hover {
          background-color: ${rgba(WHITE, 0.08)};
          color: ${WHITE};
          border-color: ${WHITE};

          .MuiButton-label {
            color: ${WHITE};
          }
        }

        &:disabled {
          color: ${rgba(WHITE, 0.7)};
          border: 2px solid ${rgba(WHITE, 0.7)};

          .MuiButton-label {
            color: ${rgba(WHITE, 0.7)};
          }
        }
      }
    }

    &__title {
      padding-top: 38px;
    }

    &__subtitle {
      margin-top: 5px;

      ${breakpoints.down('xs')} {
        margin-top: 10px;
        line-height: 2.4rem;
      }
    }

    &__content {
      padding: 20px 0;
      position: relative;
    }

    .sticky-outer-wrapper.active {
      .content-hero__content {
        background-color: ${p => p.theme.palette.background.contentHero};

        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 0;
          background-color: ${p => p.theme.palette.background.contentHero};
          height: 100%;
          width: 100%;
        }

        &::before {
          left: 100%;
        }

        &::after {
          right: 100%;
        }
      }
    }
  }
`;

export default Container;
